export default {
  candidate_videos: [],
  candidate_videos_errors: [],
  candidate_videos_loading: false,
  candidate_video_create_errors: [],
  candidate_video_create_loading: false,
  candidate_video_update_errors: [],
  candidate_video_update_loading: false,
};
